// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zQfcO","plus":"Card_plus__4m90h","favorite":"Card_favorite__xIvHZ"};